import * as React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


import Sidebar from './components/Sidebar';
import PartTable from './components/PartTable';
import UnitTable from './components/UnitTable';
import Header from './components/Header';

function App() {
  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <BrowserRouter>
      <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
        <Header />
        <Sidebar />
        <Box
          component="main"
          className="MainContent"
          sx={{
            px: { xs: 2, md: 6 },
            pt: {
              xs: 'calc(12px + var(--Header-height))',
              sm: 'calc(12px + var(--Header-height))',
              md: 3,
            },
            pb: { xs: 2, sm: 2, md: 3 },
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            height: '100dvh',
            gap: 1,
          }}
        >
          
          <Box
            sx={{
              display: 'flex',
              mb: 1,
              gap: 1,
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'start', sm: 'center' },
              flexWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            {/* <Typography level="h2" component="h1">
              Parts
            </Typography> */}
          </Box>
          <Routes>
            <Route path="/" element={<PartTable />} />
            <Route path="/units" element={<UnitTable />} />
            <Route path="/parts" element={<PartTable />} />
          </Routes>
        </Box>
      </Box>
      </BrowserRouter>
    </CssVarsProvider>
  );
}

export default App;
